/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * active_total object
 * @export
 * @interface GetFwLeaderboardsCorporationsActiveTotalActiveTotal
 */
export interface GetFwLeaderboardsCorporationsActiveTotalActiveTotal {
    /**
     * Amount of kills
     * @type {number}
     * @memberof GetFwLeaderboardsCorporationsActiveTotalActiveTotal
     */
    amount?: number;
    /**
     * corporation_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsCorporationsActiveTotalActiveTotal
     */
    corporationId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsCorporationsActiveTotalActiveTotal interface.
 */
export function instanceOfGetFwLeaderboardsCorporationsActiveTotalActiveTotal(value: object): value is GetFwLeaderboardsCorporationsActiveTotalActiveTotal {
    return true;
}

export function GetFwLeaderboardsCorporationsActiveTotalActiveTotalFromJSON(json: any): GetFwLeaderboardsCorporationsActiveTotalActiveTotal {
    return GetFwLeaderboardsCorporationsActiveTotalActiveTotalFromJSONTyped(json, false);
}

export function GetFwLeaderboardsCorporationsActiveTotalActiveTotalFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsCorporationsActiveTotalActiveTotal {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'corporationId': json['corporation_id'] == null ? undefined : json['corporation_id'],
    };
}

export function GetFwLeaderboardsCorporationsActiveTotalActiveTotalToJSON(json: any): GetFwLeaderboardsCorporationsActiveTotalActiveTotal {
    return GetFwLeaderboardsCorporationsActiveTotalActiveTotalToJSONTyped(json, false);
}

export function GetFwLeaderboardsCorporationsActiveTotalActiveTotalToJSONTyped(value?: GetFwLeaderboardsCorporationsActiveTotalActiveTotal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'corporation_id': value['corporationId'],
    };
}

